import axios from "axios";
import { toast } from 'react-toastify';
const createAxiosInstance = () => {
    const headers = {
        "Content-Type": "application/json",
        "Accept": "application/json",
    };

    return axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        timeout: 30000, // 30 sec
        headers: headers,
        // withCredentials: true, // ✅ If API requires authentication
        auth: {
            username: "FUNNTPYKLWJN",
            password: "d7#Vt9X$kLp!r5Wc?yZ3uB*m",
        },
    });
};

// Usage:
const instance = createAxiosInstance();
// CancelToken source for cancelling requests
axios.CancelToken.source();
// Function to make a GET request
const logout = () => {
    localStorage.removeItem("authUser");
    localStorage.removeItem("authUser");
    localStorage.removeItem("temp");
    window.location.href = "/login"; // Redirect to login page
};
const GET = async (url) => {
    let authUser = JSON.parse(localStorage.getItem("authUser")) || null;
    
    try {
        const response = await instance.get(url,authUser? {
            headers: { 
                "Content-Type" : "multipart/form-data",
                token: `${authUser}`
            }
        }: {
            headers: { 
                "Content-Type" : "multipart/form-data",
            }
        });
        if (response.data.status === 'error' && (response.data.invalid_token === 1 || response.data.login_required === 1)) {
            if(response.data.message) {
                toast.error(response.data.message);
            }
            logout();
        }
        return response.data;
    } catch (error) {
        if(error?.status==401 || error?.status=="401"){
            toast.error("An Authentication error occurred");
            logout()
        }
        else{
        toast.error(error.response?.data?.message || "An error occurred");
        }

    }
};
  
  // Function to make a POST request
const POST = async (url, data) => {
    // let authUser = localStorage.getItem("authUser") ? localStorage.getItem("authUser") : null;
    let authUser = JSON.parse(localStorage.getItem("authUser")) || null;

    try {
        const response = await instance.post(url, data, authUser? {
            headers: { 
                "Content-Type" : "multipart/form-data",
                token: `${authUser}`
            }
        }: {
            headers: { 
                "Content-Type" : "multipart/form-data",
            }
        });
        if (response.data.status === 'error' && (response.data.invalid_token === 1 || response.data.login_required === 1)) {
            if(response.data.message) {
                toast.error(response.data.message);
            }
            logout();
        }
        return response.data;
    } catch (error) {
        if(error?.status==401 || error?.status=="401"){
            toast.error("An Authentication error occurred");
            logout()
        }
        else{
        toast.error(error.response?.data?.message || "An error occurred");
        }

        // throw error;
    }
};

const PUT = async (url, data) => {
    try {
        const response = await instance.put(url, data, {});
        //if (response.data.status) {}
        return response.data;
    } catch (error) {
        throw error;
    }
};
  
// Function to make a DELETE request
const DEL = async (url) => {
    try {
        const response = await instance.delete(url, {});
        //if (response.data.status) {}
        return response.data;
    } catch (error) {
        throw error;
    }
};
  
// Add more functions for other HTTP methods as needed

export {  GET, POST,  PUT, DEL };